import { css, Rule } from 'glamor'
import * as React from 'react'
import * as PropTypes from 'prop-types'

import { Button } from '../button'
import { Popup } from '../popup'

import DropdownList from './list'
import DropdownActionButton from './action-button'
import DropdownChecklist from './checklist'
import DropdownItem from './item'
import { UiVariant } from '../../types'

const styles = {
  wrapper: {
    base: {
      position: 'relative',
      display: 'inline-block',
      maxWidth: '100%',
    },
    block: {
      display: 'block',
    },
  },
}

const dropdownSizes = Button.SIZES
const dropdownDirections = ['up', 'down', 'left', 'right']

const variants = Button.VARIANTS

interface IDropdownProps {
  children?: React.ReactNode
  customToggle?: (props: {
    open: boolean
    toggleOpen: (e?: React.SyntheticEvent) => void
    ref: React.RefObject<HTMLDivElement>
  }) => React.ReactNode
  disabled?: boolean
  label?: React.ReactNode
  onMouseOver?: () => void
  size?: 'xSmall' | 'small' | 'large' | 'flat'
  direction?: 'up' | 'down' | 'left' | 'right'
  variant?: UiVariant | 'clear' | 'clearInverted' | 'hollowInverted' | 'link'
  block?: boolean
  flush?: boolean
  chevron?: boolean
  style?: Rule
}

export function Dropdown({
  children,
  disabled,
  label,
  block,
  size,
  direction,
  variant,
  flush,
  chevron,
  style = {},
  customToggle,
  ...additional
}: IDropdownProps) {
  return (
    <div
      {...additional}
      {...css({
        ...styles.wrapper.base,
        ...(block ? styles.wrapper.block : {}),
        ...style,
      })}
    >
      <Popup
        renderPopup={({ toggleOpen }) => {
          return <DropdownList toggleOpen={() => toggleOpen()}>{children}</DropdownList>
        }}
        renderToggle={({ toggleOpen, open, ref }) => {
          return customToggle ? (
            customToggle({ toggleOpen, open, ref })
          ) : (
            <Button
              block={block}
              direction={direction}
              disabled={disabled}
              flush={flush}
              hovered={open}
              innerRef={ref}
              multiChoice={chevron}
              onClick={toggleOpen}
              size={size}
              style={{
                maxWidth: '100%',
              }}
              type="button"
              variant={variant}
            >
              {label}
            </Button>
          )
        }}
      />
    </div>
  )
}

Dropdown.propTypes = {
  children: PropTypes.node,
  customToggle: PropTypes.func,
  disabled: PropTypes.bool,
  label: PropTypes.node,
  onMouseOver: PropTypes.func,
  size: PropTypes.oneOf(dropdownSizes),
  direction: PropTypes.oneOf(dropdownDirections),
  variant: PropTypes.oneOf(variants),
  block: PropTypes.bool,
  flush: PropTypes.bool,
  style: PropTypes.object,
  chevron: PropTypes.bool,
}

Dropdown.defaultProps = {
  size: 'large',
  variant: 'primary',
  direction: 'down',
  chevron: true,
}

export { DropdownList, DropdownActionButton, DropdownChecklist, DropdownItem }
